/**
 * Migração das chaves que guardavam a navegação antes das rotas.
 *
 * `medverse_shell` dizia se o aluno estava dentro de um curso e `medverse_pending_topic`
 * qual curso ele tentava abrir antes de logar. Com a URL fazendo os dois papéis,
 * as chaves viram lixo — mas quem estava dentro de um curso na véspera do deploy
 * abriria a raiz e cairia na vitrine. Esta função converte esse último estado em
 * uma URL, uma única vez, e apaga as chaves.
 *
 * Pode ser removida junto com estas linhas depois de algumas semanas em produção.
 */

import { getStoredUser } from '../services/authService';
import { findCourseByTopicId } from '../config/courses';

const SHELL_KEY = 'medverse_shell';
const PENDING_TOPIC_KEY = 'medverse_pending_topic';

export function migrateLegacyShell(): void {
  try {
    const shell = localStorage.getItem(SHELL_KEY);
    localStorage.removeItem(SHELL_KEY);
    localStorage.removeItem(PENDING_TOPIC_KEY);

    // Só a raiz é reescrita: qualquer outra URL já diz onde o usuário está.
    if (shell !== 'course' || window.location.pathname !== '/') return;

    const course = findCourseByTopicId(getStoredUser()?.topicId);
    if (course) {
      window.history.replaceState(null, '', `/curso/${course.slug}`);
    }
  } catch {
    // localStorage indisponível — nada a migrar.
  }
}
